'use strict';

var novicell = novicell || {};
novicell.search = novicell.search || function () {

    var searchIcon = document.getElementById('js-search-input-trigger');
    var searchForm = document.getElementById('js-search-form');
    var searchInput = document.getElementById('search-id');

    function init() {
        // Open search form
        if(searchIcon != null) {
            searchIcon.addEventListener('click', function (e) {
                e.stopPropagation();
                openSearch();
            }, true);  
        }

        // Close search form when esc pressed
        if(searchInput != null) {
            searchInput.addEventListener('keyup', function (evt) {
                evt = evt || window.event;
                if (evt.keyCode === 27) {
                    closeSearch();
                }
            }, true);
        }


        // Close search form when click outsite form element
        if(searchForm != null) {
            document.addEventListener('click', function (e) {
                var clickOnBody = e.target != searchForm && e.target.parentNode != searchForm ? true : false;
                if(searchForm.classList.contains('show-search-form') && clickOnBody){
                    closeSearch();
                }
            }, true);

            searchForm.addEventListener('submit', function (e) {
                if(searchInput.value.trim() === '') {
                    e.preventDefault();
                    e.stopPropagation();
                    closeSearch();
                }
            });
        }
    }

    function openSearch() {
        searchForm.classList.toggle('show-search-form');
        searchInput.value = '';
        setTimeout(function(){
            searchInput.focus();
        }, 50); 
    }

    function closeSearch() {
        searchForm.classList.remove('show-search-form');
    }
    return {
        init:init
    };
}();
